export const PATH_PATTERN = /^\/([A-Za-z0-9-_]+)\//;

const currentSlug = (): string => {
  const currentPath = window.location.pathname;
  const paths = PATH_PATTERN.exec(currentPath);
  return paths ? paths[1] : '';
};
export default currentSlug;
